<style lang="postcss">
	.field-footer {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		margin-top: 0;
	}
	.character-count {
		font-weight: 500;
		color: var(--base-text-color-placeholder);
		font-size: 0.7em;
		letter-spacing: -0.15px;
	}
	.character-count.has-error {
		color: var(--error-color);
	}
</style>

<script lang="ts">
	import { getContext } from "svelte";
	import FieldError from "$form/Fields/Shared/FieldError.svelte";
	import Comment from "$form/Fields/Shared/Comment.svelte";
	import Label from "$form/Fields/Shared/Label.svelte";
	import Description from "$form/Fields/Shared/Description.svelte";

	import { createEventDispatcher, onMount } from "svelte";
	export let field: FieldDisplay & { type: "Comment" };
	export let value: string;
	const styling = getContext<Styling>("styling");

	let inputRef: HTMLTextAreaElement;
	let currentLength = null;
	let maxChars =
		field.settings.maxChars && parseInt(field.settings.maxChars) > 0
			? parseInt(field.settings.maxChars)
			: false;
	const dispatch = createEventDispatcher();
	const nf = new Intl.NumberFormat();
	$: updateLength(value);
	const updateLength = (val: string) => {
		if (typeof val === "string") {
			currentLength = val.length;
		} else {
			currentLength = 0;
		}
	};
	onMount(() => {
		inputRef.addEventListener("focus", () => {
			dispatch("updateOther", {
				active: true
			});
		});
		inputRef.addEventListener("blur", () => {
			dispatch("updateOther", {
				tainted: true
			});
			dispatch("updateOther", {
				active: false
			});
		});
	});
</script>

<div
	class="field-label-cover"
	class:has-placeholder="{styling.placeholders !== false}">
	{#if field.labelHTMLComputed && field.settings.hideLabel !== true}
		{#if styling.placeholders === false}
			<Label html="{field.labelHTMLComputed}" />
		{/if}
		{#if field.descriptionHTMLComputed}
			<Description html="{field.descriptionHTMLComputed}" />
		{/if}
	{/if}
</div>
<div class="field-input-cover">
	<Comment
		bind:element="{inputRef}"
		bind:value="{value}"
		field="{field}"
		placeholder="{styling.placeholders
			? field.labelComputed
			: (field.styling?.placeholder ?? '')}" />
	<div class="field-footer">
		<FieldError
			visible="{field.tainted}"
			valid="{field.valid}"
			errorNumber="{field.errorNumber}"
			errorType="{field.errorType}" />
		{#if field.settings.showCount}
			<span
				class="character-count"
				class:has-error="{maxChars !== false && currentLength > maxChars}">
				{#if maxChars !== false}
					{nf.format(currentLength)} / {nf.format(maxChars)}
				{:else}
					{nf.format(currentLength)}
				{/if}
			</span>
		{/if}
	</div>
</div>
